import { render, staticRenderFns } from "./VatReportPrint.vue?vue&type=template&id=23c316de&"
import script from "./VatReportPrint.vue?vue&type=script&lang=js&"
export * from "./VatReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports